import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import { Row, Col } from 'react-bootstrap';

import api from 'services/api';

import { Select, Input, Text } from 'v3/components';

import {
  fetchBodies,
  fetchVehiclesTypes,
} from 'utils/fetches';

import { format } from 'date-fns';
import { validatePermission } from 'actions';
import CheckBox from 'components/CheckBox';
import { useVehicleBodies } from './context';
import {
  fetchCities,
  fetchAnttTypes,
  colors,
} from './utils';

import { fetchWagonsBrands } from 'utils/fetches';

export function Data() {
  const vehicleBody = useVehicleBodies();
  const params = useParams();
  const [anttTypes, setAnttTypes] = useState([]);
  const [rntrcExpDate, setRntrcExpDate] = useState('');
  const [modelsOptions, setModelsOptions] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicleBodyTypes, setVehicleBodyTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const hasPermissionToAlterRntrcValidated = validatePermission(
    'VALIDAR_RNTRC_VEICULO_IMPLEMENTO'
  );

  useEffect(() => {
    if (!params.id)
      vehicleBody.setData({
        city: null,
        plate: null,
        renavam: null,
        anttType: null,
        antt: null,
        rntrcExpDate: null,
        chassi: null,
        brand: null,
        model: null,
        yearModel: null,
        yearManufacture: null,
        color: null,
        totalGrossWeight: null,
        tareMass: null,
        cubage: null,
        vehicleType: null,
        bodyType: null,
        anttAdherence: null,
        rntrcValidated: false,
      });
    else {
      setRntrcExpDate(
        vehicleBody.data?.rntrcExpDate
          ? format(
            new Date(moment(vehicleBody.data?.rntrcExpDate).add(1, 'day')),
            'yyyy-MM-dd'
          )
          : null
      );
    }
  }, []);

  async function fetchOptions() {
    try {
      setLoading(true);
      let [vehicleTypesData, vehiclesBodyTypesData] =
        await Promise.all([
          fetchVehiclesTypes(),
          fetchBodies(),
        ]);
      vehicleTypesData = vehicleTypesData.filter(
        vtype => vtype?.name?.toLowerCase() === 'carrocerias'
      );
      setVehicleTypes(vehicleTypesData);
      setVehicleBodyTypes(vehiclesBodyTypesData);
    } catch (error) {
      //
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAnttTypes(setAnttTypes);
    fetchOptions();
  }, []);

  async function handleChangeBrand(value) {
    try {
      if (value?.id) {
        const response = await api.get(`v3/models/${value.id}`);
        setModelsOptions(response.data);
      }
    } catch (error) {
      if (value?.id)
        vehicleBody.showSnackbar('Erro ao buscar modelos', { type: 'error' });
    }

    vehicleBody.setData({ brand: value });
  }

  async function fetchModels(search) {
    if (vehicleBody.data.brand?.id) {
      try {
        const response = await api.get(
          `models/${vehicleBody.data.brand.id}/select?search=${search}`
        );
        return response.data;
      } catch (error) {
        return [];
      }
    }
    vehicleBody.showSnackbar('Selecione uma marca primeiro', {
      type: `error`,
    });

    return [];
  }

  function handleRntrcExpDate(value) {
    vehicleBody.setData({
      rntrcExpDate: moment(value, 'YYYY/MM/DD').format(),
    });
    setRntrcExpDate(value);
  }

  return (
    <Row className="form">
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Placa *"
          value={vehicleBody.data.plate}
          onChange={event => {
            if (event.target.value.length > 6) {
              return
            } else {
              vehicleBody.setData({ plate: event.target.value });
            }
          }}
          error={vehicleBody.errors.plate}
        />
      </Col>
      <Col className="my-2" md={6} xs={12}>
        <Select
          label="Tipo do veículo *"
          options={vehicleTypes}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          value={vehicleBody?.data?.vehicleType}
          onChange={value =>
            vehicleBody.setData({
              vehicleType: value,
              vehicle_type_id: value?.id,
            })
          }
          error={vehicleBody.errors?.vehicleType}
        />
      </Col>
      <Col md={6} xs={12} className="my-2">
        <Select
          label="Tipo do carroceria *"
          options={vehicleBodyTypes}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          value={vehicleBody?.data?.bodyType}
          onChange={value =>
            vehicleBody.setData({
              bodyType: value,
              vehicle_body_type_id: value?.id,
            })
          }
          error={vehicleBody.errors?.bodyType}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Renavam *"
          type="number"
          min={0}
          value={vehicleBody.data.renavam}
          onChange={event => vehicleBody.setData({ renavam: event.target.value })}
          error={vehicleBody.errors?.renavam}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Chassi *"
          value={vehicleBody.data.chassi}
          onChange={event =>
            event.target.value.length > 20
              ? vehicleBody.showSnackbar('Limite de dígitos para Chassi', {
                type: 'error',
              })
              : vehicleBody.setData({
                chassi: event.target.value,
              })
          }
          error={vehicleBody.errors?.chassi}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Select.Async
          label="Cidade *"
          value={vehicleBody.data?.city}
          onSearch={fetchCities}
          getOptionLabel={option => `${option?.name}, ${option?.province?.uf}`}
          getOptionValue={option => option?.id}
          onChange={value => {
            vehicleBody.setData({
              city: value,
            });
          }}
          error={vehicleBody.errors.city}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Select
          label="Tipo de RNTRC *"
          options={anttTypes}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
          value={vehicleBody.data.anttType}
          onChange={value => vehicleBody.setData({ anttType: value })}
          error={vehicleBody.errors.anttType}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="RNTRC *"
          type="number"
          min={0}
          value={vehicleBody.data.antt}
          onChange={event => vehicleBody.setData({ antt: event.target.value })}
          error={vehicleBody.errors.antt}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Validade RNTRC"
          type="date"
          value={rntrcExpDate}
          onChange={event => handleRntrcExpDate(event.target.value)}
          error={vehicleBody.errors.rntrcExpDate}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Data de emissão RNTRC *"
          type="date"
          value={vehicleBody.data.anttAdherence}
          onChange={event =>
            vehicleBody.setData({ anttAdherence: event.target.value })
          }
          error={vehicleBody.errors?.anttAdherence}
        />
      </Col>
      {hasPermissionToAlterRntrcValidated ? (
        <Col sm={12} md={6} className="my-2">
          <Text as="span" color="dark" type="label" weight={500}>
            RNTRC Validada?
          </Text>
          <div>
            <CheckBox
              checked={vehicleBody.data.rntrcValidated}
              onChange={e =>
                vehicleBody.setData({ rntrcValidated: e.target.checked })
              }
              label="Sim"
            />
          </div>
        </Col>
      ) : null}
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Ano do modelo *"
          type="number"
          min={0}
          value={vehicleBody.data?.yearModel}
          onChange={event =>
            event.target.value.length > 4
              ? vehicleBody.showSnackbar('Limite de dígitos para Ano ', {
                type: 'error',
              })
              : vehicleBody.setData({
                yearModel: event.target.value,
              })
          }
          error={vehicleBody.errors?.yearModel}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Ano de fabricação *"
          type="number"
          min={0}
          value={vehicleBody.data?.yearManufacture}
          onChange={event =>
            event.target.value.length > 4
              ? vehicleBody.showSnackbar('Limite de dígitos para Ano', {
                type: 'error',
              })
              : vehicleBody.setData({
                yearManufacture: event.target.value,
              })
          }
          error={vehicleBody.errors?.yearManufacture}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Select.Async
          label="Marca"
          onSearch={fetchWagonsBrands}
          value={vehicleBody.data.brand}
          onChange={value => handleChangeBrand(value)}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.id}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Select.Async
          label="Modelo"
          onSearch={search => fetchModels(search)}
          value={vehicleBody.data?.model}
          options={modelsOptions}
          onChange={value => vehicleBody.setData({ model: value })}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.label}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Select
          label="Cor"
          options={colors}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.value}
          value={vehicleBody.data?.color}
          onChange={value => {
            vehicleBody.setData({ color: value });
          }}
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="PBT (Peso bruto total) em kg"
          type="number"
          min={0}
          value={vehicleBody.data?.totalGrossWeight}
          onChange={event =>
            vehicleBody.setData({
              totalGrossWeight: event.target.value,
            })
          }
          placeholder="25500"
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Tara em kg"
          type="number"
          min={0}
          value={vehicleBody.data?.tareMass}
          onChange={event =>
            vehicleBody.setData({
              tareMass: event.target.value,
            })
          }
          placeholder="17440"
        />
      </Col>
      <Col md={6} className="my-2" xs={12}>
        <Input
          label="Cubagem em m³"
          type="number"
          min={0}
          value={vehicleBody.data?.cubage}
          onChange={event =>
            vehicleBody.setData({
              cubage: event.target.value,
            })
          }
          placeholder="90"
        />
      </Col>
    </Row>
  );
}
